import styled from 'styled-components';
import { key } from 'styled-theme';
import hexToRgbA from '@sizeid/commons/utils/hexToRgbA';
import shadeColor from '@sizeid/commons/utils/shadeColor';
import { media } from '@sizeid/commons/utils/styles';
import StyledAnchor from '@sizeid/commons/components/Button/styled/StyledAnchor';

import TooltipContainer from 'components/Tooltip/styled/TooltipContainer';

export default styled.div`
  ${media.lessThan('md')`
    display: none;
  `};
  margin: 60px 0;

  table {
    td,
    th {
      padding: 0;
      border: 0;
    }

    td {
      background: white;
    }

    span {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 60px;
    }

    ${StyledAnchor} {
      max-height: 100%;
      > span {
        font-size: 18px !important;
        width: 100%;
        height: 100%;
        padding: 0;
      }
    }

    tr > td:first-child + td,
    tr > th:first-child + th {
      > span {
        background: ${props =>
          hexToRgbA(props.theme.colors.SIDB.light[400], 0.2)};
        color: ${key('colors.SIDB.default')};
      }

      ~ td,
      ~ th {
        > span {
          background: ${props =>
            hexToRgbA(props.theme.colors.SIDB.light[400], 0.9)};
          color: white;
        }
      }

      ~ td:last-child,
      ~ th:last-child {
        > span {
          background: #284d73;
          color: white;
        }
      }
    }

    tr:not(:last-child) > td:last-child {
      > span {
        background: #637f99 !important;
        border-top-color: #3b5e7f;
      }
    }

    tr:not(:last-child) > td:first-child + td ~ td {
      span {
        background: ${props =>
          shadeColor(props.theme.colors.SIDB.light[400], 0.325)};
      }
    }

    td:first-child,
    th:first-child {
      width: 100%;

      span {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        color: ${key('colors.SIDB.light.400')};
        text-align: right;
        justify-content: flex-end;
        padding-right: 10px;
        ${TooltipContainer} {
          padding: 0 10px;
          p {
            white-space: normal;
            width: 150px;
            ${media.moreThan('lg')`
                width: 300px;
              `};
          }
        }
      }

      ~ td,
      ~ th {
        span {
          margin: 0 2px;
          min-width: 130px;
          white-space: nowrap;
        }
      }
    }

    td:last-child {
      span:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 100%;
        width: 10px;
        height: 100%;
        background: white;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    tr:last-child td:last-child span:after {
      display: none;
    }

    tr:last-child td {
      background: transparent;

      span {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }

    th span {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }

    tr + tr {
      td {
        span {
          border-top: 3px solid
            ${props => hexToRgbA(props.theme.colors.SIDB.light[400], 0.2)};
        }

        + td ~ td span {
          border-top-color: ${props =>
            hexToRgbA(props.theme.colors.SIDB.light[400], 0.9)};
        }

        &:first-child > span {
          border-top-color: ${key('backgrounds.graySection')};
          & > span {
            border: none;
          }
        }
      }
    }

    tr:last-child td span {
      font-weight: bold;
      border-top: 0;
    }

    tr:last-child td ~ td span,
    th ~ th span {
      font-size: 20px;
    }
  }
`;
